import AddTaskOutlinedIcon from "@mui/icons-material/AddTaskOutlined";
import { IconButton, Link, Tooltip } from "@mui/material";
import React, { useState } from "react";
import { ASSET_STATUS_URL } from "../../Constants/Constants";
import AxiosInstance from "../../services/AxiosInstance";
import LicenseForm from "./LicenseForm";
import AssetStatusForm from "./AssetStatusForm";

function AssetStatusDialog({
    assetStatusId = "",
    assetStatusName,
    variant = "button", // 'button' for add, 'link' for edit
    onSuccess,
}) {
    const [open, setOpen] = useState(false);
    const [editData, setEditData] = useState(null);
    const [loading, setLoading] = useState(false);

    const handleClickOpen = async () => {
        if (assetStatusId && assetStatusId !== "") {
            setLoading(true);
            try {
                const response = await AxiosInstance.get(
                    `${ASSET_STATUS_URL}/${assetStatusId}`
                );
                setEditData(response.data);
                setOpen(true);
            } catch (error) {
                console.error("Error fetching Asset Status data:", error);
            } finally {
                setLoading(false);
            }
        } else {
            setEditData(null);
            setOpen(true);
        }
    };

    const handleClose = () => {
        setOpen(false);
        setEditData(null);
    };

    const renderTrigger = () => {
        if (variant === "link" && assetStatusId) {
            return (
                <Link
                    component="button"
                    onClick={handleClickOpen}
                    disabled={loading}
                    sx={{
                        cursor: "pointer",
                        textDecoration: "none",
                        color: "primary.main",
                        "&:hover": {
                            textDecoration: "underline",
                        },
                    }}
                >
                    {assetStatusName}
                </Link>
            );
        }

        return (
            <Tooltip
                title="Asset Status"
                onClick={handleClickOpen}
                disabled={loading}
            >
                <IconButton
                    sx={{
                        cursor: "pointer",
                        margin: "2px",
                        color: (theme) => theme.palette.grey[500],
                        borderRadius: 2,
                        border: 1,
                        borderColor: "divider",
                    }}
                >
                    <AddTaskOutlinedIcon color="primary" />
                </IconButton>
            </Tooltip>
        );
    };

    return (
        <>
            {renderTrigger()}
            <AssetStatusForm
                open={open}
                onClose={handleClose}
                editData={editData}
                onSuccess={onSuccess}
                isEditMode={Boolean(editData)}
            />
        </>
    );
}
export default AssetStatusDialog;
